import { css } from '@emotion/core'
import * as MQ from 'styles/media-queries'
import { colors, measures, spacing, font } from 'styles/variables'

const { unit } = measures

export const inWinsLink = css`
  ${MQ.PHONES} {
    display: none;
  }
`

export const count = css`
  color: ${colors.white100};
`

export const plus = css`
  background-color: ${colors.greens.green7};
  border-radius: 50%;
  width: ${unit * 1.25}px;
  height: ${unit * 1.25}px;
  padding: ${spacing(0.75)};
  color: ${colors.black90} !important;
`

export const link = css`
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  height: ${unit * 6}px;
  box-sizing: border-box;
  gap: ${spacing(1.25)};
  padding: ${spacing(1.5)};
  border-radius: ${1.25 * unit}px;
  border: 1px solid ${colors.grays.gray7};
  color: ${colors.white60};
  transition: all 0.3s ease;

  font-family: ${font.family};
  :hover {
    border: 1px solid ${colors.greens.green7};
    color: ${colors.greens.green7};
  }
`
